import './style.scss'

export default {
  name: 'Page',
  props: {
    title: {
      type: String,
      default: ''
    },

    border: {
      type: Boolean,
      default: true
    }
  },
  render() {
    const { title , $scopedSlots } = this
    let header = $scopedSlots.header ? $scopedSlots.header() : title ? <div class="page-header">
        <span class="page-title">{title}</span>
      </div> : null

    let body = $scopedSlots.default ? $scopedSlots.default() : null
    return <div class="sl-page">
      { header }
      <div class="page-body">
        { body }
      </div>
    </div>
  }
}
